/* eslint-disable react-refresh/only-export-components */
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { RootLayout } from '@base/ui/layouts/root-layout';
import { TicketListPage } from '../ticket-list/ticket-list-page';
import { CreateTicketPage } from '../create-ticket/create-ticket-page';
import { DetailPage } from '../ticket-detail/detail-page';
import { EditPage } from '../edit-ticket/edit-page';
import { ROUTES } from './route-constants';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: ROUTES.LIST,
        element: <TicketListPage />,
      },
      {
        path: ROUTES.CREATE,
        element: <CreateTicketPage />,
      },
      {
        path: ROUTES.DETAIL,
        element: <DetailPage />,
      },
      {
        path: ROUTES.EDIT,
        element: <EditPage />,
      },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
